import * as React from "react";
import LoginPopup from "../generic/loginPopup";
import DeviceContext from "../../../services/indentifyDevice";
import { ELoginPopupState } from "../../../Containers/Client/Login/loginConstants";
import "../../../assets/scss/Login/login/loginScreen/loginScreen.scss";
import { Link, RouteChildrenProps } from "react-router-dom";
import LoginStatusScreen from "./loginStatusScreen";
import LoginService from "../../../services/login/loginService";
import UnblockAccountForm from "../forms/unblockAccForm";
import NuvamaLogo from "../../../assets/new_images/nuvama-logo.svg";

export interface IForgotScreenProps {}

export interface IForgotScreenState {
  popupMessage: string;
}

class UnblockAccount extends React.Component<
  IForgotScreenProps & RouteChildrenProps,
  IForgotScreenState
> {
  state = { popupMessage: "" };

  get routeParam() {
    return this.props.match!.path.split("/")[2];
  }

  onClose = () => {
    this.props.history.push("/login/help");
  };

  render() {
    return (
      <>
        <LoginPopup
          leftHeaderContent={
            <Link
              to="/login/help"
              className="ed_button link action icon_button"
            >
              <i className="arrow_left edel-icon-arrow-left vTextTop" />
              <span>Back</span>
            </Link>
          }
          centerHeaderContent={
            DeviceContext().isDesktop ? (
              <img className="logo1" src={NuvamaLogo} alt="nuvama-logo" />
            ) : (
              <h1 className="title">Unblock Account</h1>
            )
          }
          // don't show close button in vendor login
          onClose={LoginService.hideCross ? undefined : this.onClose}
          className="login_scrn frgt_id_form"
        >
          {DeviceContext().isDesktop && (
            <div className="Login_help_header">
              <h1 className="title">Unblock Account</h1>
            </div>
          )}

          <UnblockAccountForm
            onSuccess={(popupMessage) => this.setState({ popupMessage })}
          />
        </LoginPopup>
        {this.state.popupMessage && (
          <LoginStatusScreen
            popupState={ELoginPopupState.LOGINID_SENT}
            title={"Success"}
            message={this.state.popupMessage}
            onClose={LoginService.hideCross ? undefined : this.onClose} // don't show close button in vendor login
          />
        )}
      </>
    );
  }
}

export default UnblockAccount;
